import Header from "./header.jsx";
import ProductPage from "./product-page.jsx";
import Camp from "./camp.jsx";
import { Router, Route, Routes } from "react-router-dom";
import Footer from "./footer.jsx";

export default function Home() {
  return (
    <div className="App">
      <div className="Appbackgroundcolor">
        <div className="header-main">
          <Header />
        </div>
        <div>
          <ProductPage />

        </div>
        <div>
          {/* <Footer/> */}
        </div>
        <div>
          <footer id="footer-section" className="fl-page-footer-wrap" itemScope="itemScope" itemType="https://schema.org/WPFooter">


            <div className="fl-page-footer">
              <div className="fl-page-footer-container container">
                <div className="fl-page-footer-row row">
                  <div className="col-sm-9 col-md-9 text-left clearfix">
                    <div className="footer-links">
                      <a href="#">Our Story</a>
                      <a href="#">News</a>
                      <a href="#">Webinars</a>
                      <a href="#">Events</a>
                      <a href="#">Partner Program</a>
                      <a href="#">Careers</a>
                      <a href="#">Resource Library</a>
                      <a href="#">Security & Privacy</a>
                    </div>
                  </div>

                  <div className="col-sm-9 col-md-9 text-left clearfix">
                    <div className="footer-links">
                      <h1 className="fl-heading" >
                        {/* <span className="heading-1"> */}
                        <span style={{ color: '#ffffff' }}>India's most Trusted</span> <span style={{ color: '#ffffff' }}>School Management Software</span>
                        {/* </span> */}
                      </h1>
                      <p>
                        SchoolWave is an all-in-one school management platform <br />designed to simplify and streamline day-to-day school operations.
                      </p>
                    </div>
                  </div>
                  <div>
                    {/* <h1 className="fl-heading" >
                      <span className="heading-1">
                      <span style={{color:'#010041'}}>India's most Trusted</span> <span style={{color:'#e8511f'}}>School Management Software</span>                                
                      </span>
                    </h1>  */}
                  </div>
                  <div className="col-sm-3 col-md-3 text-right clearfix">
                    <div className="fl-page-footer-text fl-page-footer-text-2">
                      <div className="footer-contact">
                        <h3 className="fl-heading" >CONTACT US</h3>
                        <p>JBA Arcade, 2nd Floor <br />
                          1st Cross, S S Circle <br />
                          Ashok Nagar <br />
                          Tumkuru-572103 <br />
                          +91 9380606269
                        </p>

                        <a href="mailto:Support@Schoolwave.in"><strong>Support@Schoolwave.in</strong></a>
                        <div className="fl-social-icons">
                          <div className="social-icons">
                            <a href="https://www.facebook.com/share/14aqMKDSNem/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f" ></i></a>
                            <a href="https://x.com/schoolwave25?s=21" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
                            {/* <i className="fab fa-linkedin"><a href="https://www.linkedin.com/company/schoolwave" target="_blank" rel="noopener noreferrer"></a></i> */}
                            <a href="https://youtube.com/@schoolwave_official?si=ur5NZSZHDfmW5Kly" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
                            <a href="https://www.instagram.com/schoolwave25?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="fl-page-footer">
              <div className="fl-page-footer-container container form-container">
                <div className="copyright">
                  &copy; Copyright 2026 SchoolWave. All rights reserved.  SchoolWave a product of <a href="https://www.technotharanga.com/">Technotharanga</a>
                  <br />
                </div>
              </div>
            </div>
          </footer>

        </div>
      </div>
    </div>
  )
}